import React from 'react';
import './Resume.css';

function Resume() {
  return (
    <div className="resume-container" id="resume-print">
      {/* Header */}
      <div className="resume-header">
        <h1 className="resume-name">PRAKASH CHOUDHARY</h1>
        <div className="resume-title">Full Stack Developer | Machine Learning Engineer</div>
        <div className="resume-contact-info">
          <span>📧 prakash18052006@gmail.com</span>
          <span>📍 Bikaner, Rajasthan</span>
          <span>🔗 linkedin.com/in/codepc</span>
          <span>💻 github.com/pc-daukiya</span>
        </div>
      </div>

      {/* Professional Summary */}
      <div className="resume-section">
        <h2 className="resume-section-title">PROFESSIONAL SUMMARY</h2>
        <p className="resume-text">
          Passionate Full Stack Developer and ML Engineer with 3+ years of experience. CEO & Founder of Trivana Hospitality. 
          Expertise in React, Node.js, Python, and modern web technologies. Proven track record in building scalable applications 
          and intelligent AI solutions.
        </p>
      </div>

      {/* Two Column Layout for Experience and Education */}
      <div className="resume-two-column">
        {/* Work Experience */}
        <div className="resume-column">
          <div className="resume-section">
            <h2 className="resume-section-title">WORK EXPERIENCE</h2>
            
            <div className="resume-item-compact">
              <h3 className="resume-job-title">CEO & Founder</h3>
              <p className="resume-company">Trivana Hospitality</p>
              <p className="resume-date-loc">Apr 2025 - Present | Bikaner</p>
              <ul className="resume-list">
                <li>Leading technical development and business operations</li>
                <li>Building technology solutions for hospitality industry</li>
              </ul>
            </div>

            <div className="resume-item-compact">
              <h3 className="resume-job-title">ML & Data Visualization Intern</h3>
              <p className="resume-company">Future Intern</p>
              <p className="resume-date-loc">Apr 2025 | Remote</p>
              <ul className="resume-list">
                <li>Developed ML models and data visualization dashboards</li>
              </ul>
            </div>

            <div className="resume-item-compact">
              <h3 className="resume-job-title">Full-time Intern</h3>
              <p className="resume-company">KRASHAK INNOVATIVE SOLUTION</p>
              <p className="resume-date-loc">Mar 2024 - Jan 2025 | Bikaner</p>
              <ul className="resume-list">
                <li>Built soil health testing device website with C, C++, Python</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Education */}
        <div className="resume-column">
          <div className="resume-section">
            <h2 className="resume-section-title">EDUCATION</h2>
            
            <div className="resume-item-compact">
              <h3 className="resume-job-title">B.Tech CSE</h3>
              <p className="resume-company">Govt. Engineering College Bikaner</p>
              <p className="resume-date-loc">2023 - 2027</p>
            </div>

            <div className="resume-item-compact">
              <h3 className="resume-job-title">JEE Preparation</h3>
              <p className="resume-company">Allen Carrier Institute Kota</p>
              <p className="resume-date-loc">2022 - 2023</p>
            </div>
          </div>

          <div className="resume-section">
            <h2 className="resume-section-title">ACHIEVEMENTS</h2>
            
            <div className="resume-item-compact">
              <ul className="resume-list">
                <li><strong>GSSoC 2024</strong> - Open Source Contributor</li>
                <li><strong>Hackathon</strong> - 3rd Position at GEC Bikaner</li>
                <li><strong>DevFest AI</strong> - AI/ML Development</li>
                <li><strong>Mood Indigo IIT Bombay</strong> - Contingent Leader</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Technical Skills */}
      <div className="resume-section">
        <h2 className="resume-section-title">TECHNICAL SKILLS</h2>
        
        <div className="skills-compact">
          <p><strong>Frontend:</strong> HTML5, CSS3, JavaScript, React, Bootstrap, Tailwind CSS, jQuery</p>
          <p><strong>Backend:</strong> Node.js, Express.js, PHP, Spring Boot, REST API</p>
          <p><strong>Languages:</strong> C, C++, Java, Python, JavaScript, TypeScript</p>
          <p><strong>Database:</strong> MySQL, MongoDB, PostgreSQL, Firebase</p>
          <p><strong>Tools:</strong> Git, GitHub, VS Code, Postman, Docker, Linux, npm</p>
          <p><strong>ML/AI:</strong> TensorFlow, Pandas, NumPy, Scikit-learn</p>
        </div>
      </div>

      {/* Key Projects */}
      <div className="resume-section">
        <h2 className="resume-section-title">KEY PROJECTS</h2>
        
        <div className="resume-item-compact">
          <p><strong>Hospital Management System:</strong> Comprehensive system with patient records, appointments, and inventory. Built with React, Node.js, MongoDB.</p>
        </div>

        <div className="resume-item-compact">
          <p><strong>E-Commerce Platform:</strong> Full-featured platform with product catalog, cart, and payment integration. React, Express.js, MySQL.</p>
        </div>

        <div className="resume-item-compact">
          <p><strong>Weather Forecasting App:</strong> Real-time weather application with location-based forecasts. JavaScript and API integration.</p>
        </div>
      </div>
    </div>
  );
}

export default Resume;
